export const countriesPath = {
  countries: "countries-mini/all-countries",
}
